"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ArrowRight = function () { return (react_1.default.createElement("svg", { width: "6", height: "12", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement("path", { d: "M.6 11.4L5.4 6 .6.6", stroke: "#1F1F1F", strokeLinecap: "round", strokeLinejoin: "round" }))); };
exports.default = ArrowRight;
//# sourceMappingURL=ArrowRight.js.map